module.exports = __webpack_public_path__ + "static/media/road.883234ed.svg";